module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "flex bg-white new-shadow-theme br3 custom-padding responsive-box",
    class: _vm.isSomeComplete ? 'mr5' : 'custom-width'
  }, [_c('div', {
    staticClass: "flex flex-column w-100 responsive-plan"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f4 mb3 fw5 pl3-l"
  }, [_vm._v("Choose Your Plan")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row flex-wrap w-100 justify-between cards mv2"
  }, [_c('plan-select-toggle-c3', {
    attrs: {
      "isPhoneOnly": _vm.isPhoneOnly,
      "setAkkoPlan": _vm.setAkkoPlan,
      "setPhonePlan": _vm.setPhonePlan,
      "setValue": _vm.setValue
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-077275c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/selectBox/SelectPlan3c.vue
// module id = 784
// module chunks = 0